import {
  AppData,
  ToolsMenuItemOptions,
  ToolsPanelOptions,
} from '@wix/editor-platform-sdk-types';
import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import {
  toolsEntryStore,
  ToolsEntryStoreApi,
} from '../../services/toolsEntryService';
import { UrlDecorator } from '../../utils/urlDecorator';
import { AppData as DSAppData } from '@wix/document-services-types';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

export const toolsPanelEnhancer: PlatformApiEnhancerFunction = (
  platformApiMethods,
  { urlDecorator },
) => {
  const {
    registerToolsPanel,
    registerToolsPanelWithOpener,
    unregisterToolsPanel,
  } = createToolsPanelMethods(
    platformApiMethods,
    toolsEntryStore,
    urlDecorator,
  );
  return {
    editor: {
      registerToolsPanel,
      registerToolsPanelWithOpener,
      unregisterToolsPanel,
    },
  };
};

function createToolsPanelMethods(
  platformApiMethods: PlatformApiMethods,
  toolsEntryAPI: ToolsEntryStoreApi,
  urlDecorator: UrlDecorator,
) {
  function registerToolsPanelWithOpener(
    appData: AppData,
    { title: toolsMenuItemTitle }: ToolsMenuItemOptions,
    {
      title: providedPanelTitle,
      url,
      width,
      height,
      initialPosition,
      initialData,
    }: ToolsPanelOptions,
  ): () => Promise<void> {
    const { appDefinitionId } = appData;
    if (!appDefinitionId) {
      throw new Error(`appDefinitionId is missing`);
    }

    const openPanel = () =>
      platformApiMethods.editor.openFloatingToolPanel(
        { appDefinitionId } as DSAppData,
        '',
        {
          title: providedPanelTitle || toolsMenuItemTitle,
          url: urlDecorator.decorateWithOrigin(url),
          width,
          height,
          initialPosition,
          initialData,
          token: '',
          appDefinitionId,
        },
      );

    toolsEntryAPI.set({
      appDefinitionId,
      toolsMenuItem: { title: toolsMenuItemTitle },
      onClick: openPanel,
    });

    return openPanel;
  }

  function registerToolsPanel(
    appData: AppData,
    toolsMenuItemOptions: ToolsMenuItemOptions,
    toolsPanelOptions: ToolsPanelOptions,
  ): void {
    registerToolsPanelWithOpener(
      appData,
      toolsMenuItemOptions,
      toolsPanelOptions,
    );
  }

  function unregisterToolsPanel(appData: AppData): void {
    const { appDefinitionId } = appData;
    if (!appDefinitionId) {
      throw new Error(`appDefinitionId is missing`);
    }
    toolsEntryAPI.remove(appDefinitionId);
  }

  return {
    registerToolsPanel,
    registerToolsPanelWithOpener,
    unregisterToolsPanel,
  };
}
